import {
    Component,
    AfterContentInit,
    ContentChildren,
    OnInit,
    QueryList,
    HostBinding,
    Input,
    OnDestroy
} from '@angular/core';
import { AccordionGroupComponent } from './accordion-group/accordion-group.component';
import { Subscription } from 'rxjs';

@Component({
    standalone: false,
    selector: 'accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss']

})
export class AccordionComponent implements OnInit, AfterContentInit, OnDestroy {
    @HostBinding('class')
    readonly hostClass = 'accordion';

    @ContentChildren(AccordionGroupComponent)
    groups: QueryList<AccordionGroupComponent>;

    @Input()
    allowMultipleOpenedSections: boolean = false;

    private openedSections: number[] = [];

    private subscriptions: Subscription[] = [];

    constructor() {}

    ngOnInit() {}

    ngAfterContentInit() {
        this.initToggleSubscriptions();
    }

    setActive(index) {
        if (!this.allowMultipleOpenedSections) {
            this.openedSections = this.openedSections[0] === index ? [] : [index];
        } else {
            this.openedSections =
                this.openedSections.indexOf(index) >= 0
                    ? this.openedSections.filter(sectionNumber => sectionNumber !== index)
                    : this.openedSections.concat([index]);
        }
        this.groups.forEach((group, i) => {
            this.openedSections.indexOf(i) < 0 ? (group.active = false) : (group.active = true);
        });
    }

    initToggleSubscriptions() {
        this.removeSubscriptions();
        this.subscriptions = this.groups.map((group, i) => {
            return group.toggle.subscribe(() => this.setActive(i));
        });
        this.openedSections = [];
        this.setActive(0);
    }

    removeSubscriptions() {
        this.subscriptions.forEach(subscription => !subscription.closed && subscription.unsubscribe());
    }

    ngOnDestroy(): void {
        this.removeSubscriptions();
    }
}
